import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from 'src/domains/common/universes/londonbet/londonbet.features';
import { themeColors } from 'src/domains/common/universes/londonbet/londonbet.config';
import LondonBetLoginImage from 'src/layouts/LoginPage/loginBgImages/LondonBetLoginImage.jpg';
import { LondonBetBrandIconWrapper, CompliancePopupLogo } from 'src/domains/common/universes/londonbet/londonbet.style';
import { LondonbetLogotype } from 'src/domains/common/universes/londonbet/londonbet.logotype';
import { LondonBetLogo } from 'src/assets/logos/LondonBetLogo';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'LondonBet Backoffice',
    urls: {
        website: 'https://www.london.bet/',
        backoffice: 'https://backoffice.london.bet/',
    },
    BrandIcon: () => <LondonBetBrandIconWrapper />,
    Logotype: () => <LondonbetLogotype />,
    LogotypeLoginPage: () => <LondonBetLogo />,
    compliancePopupLogo: () => <CompliancePopupLogo />,
    loginImageContainer: () => <LoginImageWrapper imgSrc={LondonBetLoginImage} />,
};
